<template>
  <div class="app-container">
    <!--加载进度-->
    <van-loading v-if="!isLoaded" class="loading" />
    <!--加载失败-->
    <div v-else-if="errorMessage" class="error-message">
      错误：{{ errorMessage }}
    </div>
    <!--加载成功-->
    <template v-else>
      <van-cell class="application-info">
        <div>业务号：{{ xtInstanceInfo.iId }}</div>
      </van-cell>
      <ProcessSteps :case-records="caseRecords" />
    </template>
  </div>
</template>

<script>
import { ApplicationStatus } from '@/utils/enums.js'
import { getXtInstance, getCaseRecordList } from '@/api/xtInstance'
import ProcessSteps from '@/views/application/components/ProcessSteps'
export default {
  components: {
    ProcessSteps
  },
  filters: {
    applicationStatusName: function(status) {
      return ApplicationStatus.getTextByValue(status)
    }
  },
  data() {
    return {
      isLoaded: false,
      errorMessage: '',
      xtInstanceInfo: {},
      caseRecords: []
    }
  },
  created() {
    // 加载数据
    this.loadData()
  },
  methods: {
    // 加载数据
    async loadData() {
      // 业务iId
      const iId = this.$route.query.iId || this.$route.params.iId
      const open_id = this.$store.getters.webUserInfo.openId
      Promise.all([getXtInstance({ iId, open_id }), getCaseRecordList({ iId: iId })])
        .then(([response1, response2]) => {
          // 设置案卷信息
          this.xtInstanceInfo = response1.data
          // 案卷记录
          this.caseRecords = response2.data
        })
        .catch(error => {
          // 设置错误信息
          this.errorMessage = error.message
        })
        .finally(() => {
          // 设置加载状态为已加载
          this.isLoaded = true
        })
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  .loading {
    padding-top: 15px;
    text-align: center;
  }
  .error-message {
    color: #ee0a24;
    padding-top: 15px;
    text-align: center;
  }
  .application-info {
    font-weight: 700;
  }
}
</style>
